import OneStopSearchResultsLayout from 'domain/gpo/oneStop/List/OneStopSearchResultsLayout';
import { SearchWithKeyboardNavigation as SearchInput } from 'framework/list';

type KeyboardNavigationWrapperProps = {
  isSearchMode: boolean;
};

const SearchWithKeyboardNavigation = ({ isSearchMode }: KeyboardNavigationWrapperProps) => {
  return (
    <SearchInput
      sxWrapper={{
        marginBottom: '0.75rem',
        '@media (max-width: 991px)': {
          marginBottom: 0,
        },
        '& .react-autosuggest__input': {
          minWidth: '100% !important',
          width: '100%',
        },
      }}
      searchResultsLayout={OneStopSearchResultsLayout}
      isSearchMode={isSearchMode}
      placeholder="Search by your request type, process or solution"
    />
  );
};

export default SearchWithKeyboardNavigation;
